import { isoDate } from "@core/foundation/date";
import { identity } from "@core/foundation/function";
import {
  createModel,
  createModelId,
  createModelSchemas,
} from "@core/foundation/model";
import { z } from "@core/zod";

import { ID_PREFIX } from "../../shared/id-prefix.ts";

const { generateId: generateUserId, idSchema: UserIdSchema } = createModelId({
  idPrefix: ID_PREFIX.USER,
});

export { UserIdSchema };

export type UserId = z.infer<typeof UserIdSchema>;

export const User = createModel({
  create: item => {
    return { ...item, createdAt: isoDate(), id: generateUserId() };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        createdAt: z.iso.datetime(),
        id: UserIdSchema,
        name: z.string().optional(),
      },
      {
        createdAt: "When the user was created, as an ISO 8601 timestamp.",
        id: "The unique identifier for the user.",
        name: "The user's display name, when one was given.",
      },
    ),
    derive: {
      create: schema => schema.omit({ createdAt: true, id: true }),
      recovery: identity,
      update: schema => schema.pick({ name: true }).partial(),
    },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface User extends z.infer<typeof User.schema> {}
